const styleicons = {};

styleicons.cta_layout_1 = (
  <span className="cta_layout cta_layout_1">
    <span className="dashicons dashicons-format-image"></span>
    <span className="cta-info-icon"></span>
  </span>
);
styleicons.cta_layout_2 = (
  <span className="cta_layout cta_layout_2">
    <span className="dashicons dashicons-format-image"></span>
    <span className="cta-info-icon"></span>
  </span>
);
styleicons.cta_layout_3 = (
  <span className="cta_layout cta_layout_3">
    <span className="dashicons dashicons-format-image"></span>
    <span className="cta-info-icon"></span>
  </span>
);
styleicons.cta_layout_4 = (
  <span className="cta_layout cta_layout_4">
    <span className="dashicons"></span>
    <span className="cta-info-icon"></span>
  </span>
);
styleicons.cta_layout_5 = (
  <span className="cta_layout cta_layout_5">
    <span className="dashicons"></span>
    <span className="cta-info-icon"></span>
  </span>
);
styleicons.cta_layout_6 = (
  <span className="cta_layout cta_layout_6">
    <span className="dashicons"></span>
    <span className="cta-info-icon"></span>
  </span>
);
styleicons.cta_layout_7 = (
  <span className="cta_layout cta_layout_7">
    <span className="dashicons"></span>
    <span className="cta-info-icon"></span>
  </span>
);
styleicons.cta_layout_8 = (
  <span className="cta_layout cta_layout_8">
    <span className="dashicons dashicons-format-image"></span>
    <span className="cta-info-icon"></span>
  </span>
);
styleicons.cta_layout_9 = (
  <span className="cta_layout cta_layout_9">
    <span className="dashicons"></span>
    <span className="cta-info-icon"></span>
  </span>
);
styleicons.cta_layout_10 = (
  <span className="cta_layout cta_layout_10">
    <span className="dashicons"></span>
    <span className="cta-info-icon"></span>
  </span>
);
styleicons.cta_layout_11 = (
  <span className="cta_layout cta_layout_11">
    <span className="dashicons"></span>
    <span className="cta-info-icon"></span>
  </span>
);
styleicons.cta_layout_12 = (
  <span className="cta_layout cta_layout_12">
    <span className="dashicons dashicons-format-image"></span>
    <span className="cta-info-icon"></span>
  </span>
);

export default styleicons;
